<template>
  <div>
    <!-- 页面信息 -->
    <div class="top">
      <div>{{ totalPrice }}</div>
      <div>应付金额(元)</div>
    </div>
    <div class="box">
      <div class="item">
        <div>订单详情</div>
        <div>订单支付</div>
      </div>
      <div class="item">
        <div>订单金额</div>
        <div>{{ totalPrice }}元</div>
      </div>
    </div>
    <div class="item bg" @click="search">
      <div>付款方式</div>
      <div class="cardNum">
        <span v-if="card.length != 0">农业银行储蓄卡({{ selectVal.slice(-4) }})</span>
        <span v-else>请绑定银行卡</span>
        <div class="iconfont icon-xiangyou rotate"></div>
      </div>
    </div>
    <form :action="sTrustPayIETrxURL" method="post" name="form2">
      <input name="MSG" :value="tSignature" type="hidden"/>
      <input name="errorPage" :value="sErrorUrl" type="hidden"/>
      <input type="submit" value="支付" class="btn">
      <!-- <div class="btn" @click="pay">支 付</div> -->
    </form>
    

    <!-- 6228481426735143675 -->

    <!-- 付款方式 -->
    <div class="model" v-if="show">
      <div class="list">
        <div class="title">
          <div></div>
          <div>付款方式</div>
          <div class="img" @click="close">
            <img src="../../assets/images/del.png" />
          </div>
        </div>
        <div class="card" v-for="(item,index) in card" :key="item">
          <div>农业银行储蓄卡({{ item.slice(-4) }})</div>
          <div><input type="radio"  @click="select" name="radios" :data-key='item' :value="index" v-model="radio"/></div>
        </div>
        <div class="addCard" @click="add">
          <div>添加银行卡</div>
          <div class="iconfont icon-xiangyou"></div>
        </div>
      </div>
    </div>

    <!-- 银行卡绑定 -->
    <div class="model1" v-if="addShow">
      <div class="head">
        <div class="icon" @click="back"><div class="iconfont icon-xiangyou rotate180" ></div></div>
        <div class="topTitel">添加银行卡</div>
        <div></div>
      </div>
      <div class="tip">填写银行卡号</div>
      <div class="inp"><input type="number" placeholder="请输入银行卡号" v-model="codeNumber" /></div>
      <div class="inp"><input type="number" placeholder="请输入手机号" v-model="account" /></div>
      <div class="inpCode">
          <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
          <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
          </button>
      </div>
      <div class="btn" @click="bind">绑定</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getOrderInfo, agriculturalPay } from "@api/order";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { registerVerify, getCodeApi, bindCard } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import attrs, { required, chs_phone, alpha_num, num } from "@utils/validate";
import { VUE_APP_API_URL } from "@utils";
const NAME = "OrderSubmission";
export default {
  name: NAME,
  mixins: [sendVerifyCode],
  data() {
    return {
      orderID: "",
      uid: "",
      show: false,
      totalPrice: 0,
      addShow: false,
      keyCode: "",
      account: "",
      captcha: "",
      codeNumber: "",
      isShowCode: false,
      card:'',
      radio: 0,
      selectVal: '',
      num:'',
      sErrorUrl:'',
      sTrustPayIETrxURL:'',
      tSignature:''
    };
  },

  mounted() {
    this.orderID = this.$route.params.id;
    this.getOrderInfo();
  },

  methods: {
    search() {
      this.show = true;
    },

    close() {
      this.show = false;
    },

    select(e){
      this.selectVal = e.target.dataset.key;
    },

    getOrderInfo() {
      getOrderInfo({ id: this.orderID }).then((res) => {
        this.totalPrice = res.data.result.total_sum;
        this.uid = res.data.result.uid;
        this.card = res.data.result.card;
        this.num = res.data.result.num;
        this.selectVal = res.data.result.card[this.radio]
        this.pay()
      });
    },

    add() {
      this.addShow = true;
      getCodeApi().then(res => {
          this.keyCode = res.data.key;
        }).catch(res => {
          this.$dialog.error(res.msg);
        });
    },

    back(){
      this.addShow = false;
      this.show = false;
    },

    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      await registerVerify({
        phone: that.account,
        type: 'login',
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },

    async bind() {
      let that = this;
      const { account, codeNumber, captcha } = this;
      try {
        await this.$validator({
          codeNumber: [
            required(required.message("银行卡号")),
            attrs.range([19, 19], attrs.range.message("银行卡号")),
            num(num.message())
          ],
          account: [
            required(required.message("手机号码")),
            attrs.range([11, 11], attrs.range.message("手机号码")),
            chs_phone(chs_phone.message())
          ],
          captcha: this.isShowCode
            ? [
                required(required.message("验证码")),
                attrs.length(4, attrs.length.message("验证码")),
                alpha_num(alpha_num.message())
              ]
            : []
        }).validate({ account, codeNumber, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      bindCard({ account:this.account, codeNumber: this.codeNumber, captcha: this.captcha, uid: this.uid.uid })
        .then(({ data }) => {
          if(data.status == "SUCCESS"){
            that.account = '';
            that.codeNumber = '';
            that.captcha = '';
            that.isShowCode = false;
            that.addShow = false;
            that.show = false;
            this.$dialog.success(data.msg);
          }
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    },

    pay(){
      var data = {
        PayTypeID: 'ImmediatePay',
        CurrencyCode: '156',
        OrderAmount: this.totalPrice,
        InstallmentMark: '0',
        CommodityType: '0202',
        PaymentType: 'A',
        PaymentLinkType: '1',
        AccountNo: this.selectVal,
        num: this.num
      }
      console.log(data)
      agriculturalPay(data).then(res=>{
        this.sErrorUrl = res.data.result.sErrorUrl;
        this.sTrustPayIETrxURL = res.data.result.sTrustPayIETrxURL;
        this.tSignature = res.data.result.tSignature;
      });
    }, 

  },

  watch:{
    card(newVal,oldVal){
      this.selectVal = newVal[this.radio]
    }
  }
};
</script>

<style>
.top {
  width: 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}

.top div:first-child {
  font-size: 25px;
  font-weight: bold;
}

.box {
  width: 92%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 6px;
}

.box .item:first-child {
  border-bottom: 1px solid #ccc;
}

.item {
  width: 90%;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.cardNum {
  display: flex;
  align-items: center;
}

.cardNum span {
  margin-right: 6px;
}

.bg {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 6px;
  padding: 0 14px;
}

.btn {
  display: block;
  width: 92%;
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  margin: 40px auto 0 auto;
  background-color: #f44939;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.model {
  width: 100%;
  height: 100%;
  background-color: #cccccc5c;
  position: fixed;
  top: 0;
  bottom: 0;
}

.list {
  position: absolute;
  left: 0;
  right: 0;
  top: 54%;
  bottom: 0;
  background-color: #fff;
}

.title {
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-right: 16px;
}

.img {
  width: 30px;
  height: 30px;
}

.imgR {
  width: 16px;
  height: 16px;
}

.rotate {
  transform: rotate(90deg);
}

.img img,
.imgR img {
  vertical-align: middle;
  width: 100%;
  height: 100%;
}

.card,
.addCard {
  width: 90%;
  height: 44px;
  line-height: 44px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
}

.card input {
  width: 18px;
  height: 18px;
  -webkit-appearance: radio;
}

.model1 {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
}

.model1 .head {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topTitel {
  font-size: 18px;
  font-weight: bold;
}

.icon{
  height: 100%;
  width: 10%;
  text-align: center;
}

.rotate180 {
  transform: rotate(180deg);
  line-height: 40px;
}

.tip {
  font-size: 20px;
  margin-left: 20px;
  margin-top: 16px;
}

.inp {
  height: 40px;
  text-align: center;
  margin-top: 20px;
}

.inp input {
  width: 90%;
  height: 100%;
  border-bottom: 1px solid #000;
}

.inpCode{
  width: 90%;
  height: 40px;
  margin: 0 auto;
  text-align: center;
  margin-top: 30px;
  border-bottom: 1px solid #000;
}

.inpCode input{
  width: 68%;
  height: 100%;
}

.inpCode button{
  height: 90%;
  padding: 0 16px;
  background-color: #f44939;
  border-radius: 30px;
  color: #fff;
}

</style>
